import { ApiSlugs, EmailId, EmailSummaryDto, ListPagination } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class EmailsAdminConnector extends ApiConnector<EmailSummaryDto, EmailSummaryDto, EmailId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.EMAILS);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<EmailSummaryDto[]> =>
      this.apiCaller.getRequest<EmailSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });

  resend = (emailId: EmailId): Observable<EmailSummaryDto> =>
    this.apiCaller.postRequest<EmailSummaryDto>(this.apiPrefix, `${this.slug}/${emailId}/resend`);
}
